import { sendUtagEvent } from '../../../core/analytics/utag_events'

export function initializeCtaUtagEvents() {
  sendUtagEvent({
    data: {
      event_name: 'searcher_hotel',
      event_cat: 'searcher',
      event_act: 'dates',
      event_lbl: '',
      event_purpose: 'booking',
      event_structure: 'popup',
    },
  })
}
